/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Anil Gulati",
  title: "Hi, I'm Anil",
  subTitle: emoji(
  "Full Stack & AI Engineer building production-grade systems where backend infrastructure meets intelligent automation. Experienced in designing scalable platforms, real-time systems, and AI-driven tools used across enterprise and high-impact applications."
),
  resumeLink: "https://cdn.anilgulati.com/resume.pdf",
  cvLink: "https://cdn.anilgulati.com/resume.pdf",
  displayGreeting: true
};


// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/anilfromdit",
  linkedin: "https://www.linkedin.com/in/anilfromdit/",
  gmail: "hi@anilgulati.com",
  twitter: "https://x.com/anilfromdit",
  medium: "https://medium.com/@anilfromdit",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Full Stack & AI engineering focused on scalable systems and intelligent applications",

  skills: [
    emoji("⚡ Build scalable backend systems and APIs using Java (Spring Boot) and Node.js (Express/Fastify)"),
    emoji("⚡ Design distributed systems: async workflows, event-driven pipelines, caching, and performance optimization"),
    emoji("⚡ Develop AI-powered applications: LLM integrations, data pipelines, and intelligent automation tools"),
    emoji("⚡ Work across data systems: SQL/NoSQL design, analytics pipelines, and real-world dataset modeling"),
    emoji("⚡ Cloud-native engineering: AWS (EC2, S3, RDS, Lambda), Docker, CI/CD, and production deployments"),
    emoji("⚡ Full-stack delivery when needed: React / Next.js, building usable interfaces over complex systems")
  ],

  skills2: [
    "Backend & System Design: APIs, microservices, event-driven architecture",
    "AI & Data Systems: LLMs, ML pipelines, analytics workflows",
    "Java + Spring Boot: scalable services, clean architecture",
    "Node.js: backend tooling, automation, API systems",
    "Cloud & DevOps: AWS, Docker, CI/CD pipelines"
  ],

  softwareSkills: [
    { skillName: "Java", fontAwesomeClassname: "fab fa-java" },
    { skillName: "Spring Boot", fontAwesomeClassname: "fas fa-leaf" },
    { skillName: "Node.js", fontAwesomeClassname: "fab fa-node" },
    { skillName: "JavaScript", fontAwesomeClassname: "fab fa-js" },
    { skillName: "TypeScript", fontAwesomeClassname: "fab fa-js" },
    { skillName: "React", fontAwesomeClassname: "fab fa-react" },
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" },
    { skillName: "SQL", fontAwesomeClassname: "fas fa-database" },
    { skillName: "MongoDB", fontAwesomeClassname: "fas fa-database" },
    { skillName: "AWS", fontAwesomeClassname: "fab fa-aws" },
    { skillName: "Docker", fontAwesomeClassname: "fab fa-docker" },
    { skillName: "Git", fontAwesomeClassname: "fab fa-git-alt" },
    { skillName: "Linux", fontAwesomeClassname: "fab fa-ubuntu" }
  ],

  display: true
};


// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
schoolName: "CY Tech - CY Cergy Paris Université",
logo: require("./assets/images/cy_logo.png"),
imgAlt: "CY Tech Logo",
subHeader: "Master2 – ADEO: Artificial Intelligence, Data Science & Architecture Optimization",
duration: "Sept 2025 – Present",
desc: "Coursework and projects around data mining, optimization, and ML systems.",
descBullets: [
"Focus: supervised/unsupervised learning, model evaluation, data pipelines",
"Applied projects in Python (pandas, scikit‑learn, TensorFlow), PowerBI, Tableau",
"Active in Tech events and tech meetups in Île‑de‑France"
]
},
  {
  schoolName: "DIT University",
  logo: require("./assets/images/dit_logo.webp"),
  imgAlt:"DIT University Logo",
  subHeader: "B.Tech in Computer Science Engineering",
  duration: "Aug 2020 – May 2024",
  desc: "Strong foundations in software engineering, distributed systems, and backend development.",
  descBullets: [
    "CGPA: 8.7/10",
    "Capstone: 10.0 SGPA (12 credits)",
    "Built multiple full-stack and backend projects with cloud deployment"
  ]
}

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true,
  experience: [
    { Stack: "Backend (Java / Spring Boot)", progressPercentage: "90%" },
    { Stack: "Backend (Node.js)", progressPercentage: "80%" },
    { Stack: "Cloud & DevOps", progressPercentage: "75%" },
    { Stack: "Frontend (React / React Native)", progressPercentage: "70%" },
    { Stack: "Data (SQL/NoSQL & analytics)", progressPercentage: "65%" }
  ],
  displayCodersrank: false
};


// Work experience section

const workExperiences = {
  display: true,
  experience: [

   {
  role: "Full Stack & AI Engineer",
  company: "Leaf Craft Studio Pvt. Ltd.",
  companylogo: require("./assets/images/leafCraftLogo.webp"),
  imgAlt: "Leaf Craft Logo",
  date: "Nov 2024 – July 2025",
  desc: "Built AI-driven systems and backend platforms for internal tools and client-facing applications, focusing on automation, scalability, and production reliability.",
  descBullets: [

    // 🔥 UnitsDB (core system)
    "Built UnitsDB, an AI-powered backend generation platform converting natural language into deployable APIs and microservices",
    "Engineered backend systems for Mivi AI Buds enabling real-time multi-agent AI interactions in consumer devices",
    "Designed multi-stage pipelines (generation → validation → deployment) ensuring safe, production-ready outputs",
    "Implemented schema validation and guardrails to prevent invalid system generation",
    "Handled high-frequency request patterns and optimized backend performance for user-facing AI interactions",
    "Built internal MCP-based AI systems enabling natural language interaction with structured databases",
    "Designed query translation layers converting user input into structured DB operations and visual outputs",
    "Implemented reliability patterns (timeouts, retries, validation, failure handling) improving system stability",
    "Managed hybrid infrastructure (cloud + on-prem), optimizing deployment workflows and resource utilization"
  ]
},

    {
      role: "Associate Software Engineer",
      company: "Yamaha Motor Solution India Pvt. Ltd.",
      companylogo: require("./assets/images/Yamaha.webp"),
      imgAlt: "Yamaha Logo",
      date: "Jan 2024 – Nov 2024",
      desc: "Worked on enterprise-scale Dealer Management System (YDMS), building backend systems supporting large-scale dealer operations across India.",
      descBullets: [

        "Developed backend modules within Yamaha’s Dealer Management System used across 5,000+ dealerships with high transaction volumes",
        "Built the Auto Purchase Order module using sales trend analysis, automating inventory ordering and improving procurement efficiency (~25%)",
        "Designed systems for parts and accessory management (Local Part Master), enabling standardized inventory workflows across dealers",
        "Implemented reporting modules generating profitability and operational insights for dealer decision-making",
        "Worked on distributed data handling workflows for inventory, transactions, and reconciliation processes",
        "Contributed to AWS-based parallel processing pipelines (VPC + S3), improving handling of data-heavy dealer transactions",
        "Collaborated with cross-regional teams (India, Japan) for system enhancements and architectural improvements"
      ]
    },

    {
      role: "SDE-1",
      company: "Onelab Ventures",
      companylogo: require("./assets/images/onelab_logo.webp"),
      imgAlt: "Onelab Ventures Logo",
      date: "Aug 2022 – Dec 2023",
      desc: "Delivered backend systems and applications across multiple enterprise and startup projects in a fast-paced product environment.",
      descBullets: [

        "Built backend systems for Gativan, a garage management platform used across Mumbai and Pune, handling service workflows and inventory tracking",
        "Designed and deployed Spring Boot backend services with production-grade practices (validation, error handling, logging)",
        "Contributed to Reliance Foundation applications (Machli & KisanGrow), supporting large-scale content delivery systems in rural ecosystems",
        "Developed APIs and data pipelines enabling reliable data distribution under low-connectivity constraints",
        "Worked on Kscada, building real-time industrial data ingestion and processing pipelines using AWS Lambda",
        "Implemented validation and anomaly detection workflows for machine data monitoring systems",
        "Delivered React Native applications using TDD practices, achieving stable production releases with minimal defects",
        "Built and integrated CMS-backed PWA (Strapi-based) enabling multi-device content access",
        "Managed deployments on AWS EC2 ensuring uptime, monitoring, and release stability",
        "Performed security testing (Burp Suite) and resolved vulnerabilities in authentication and API layers",

    "Developed a fintech aggregator integrating multiple banking APIs to fetch EMI/loan options using PAN and financial inputs",
      ]
    },

    // {
    //   role: "MERN Stack Intern",
    //   company: "Prepseed",
    //   companylogo: require("./assets/images/prepseed_logo.webp"),
    //   imgAlt: "Prepseed Logo",
    //   date: "May 2022 – Aug 2022",
    //   desc: "Worked on frontend systems and integrations for an education platform, contributing to production features in a team environment.",
    //   descBullets: [

    //     "Built responsive UI components for analytics dashboards and attendance workflows",
    //     "Integrated Zoom SDK enabling in-app meeting participation with stable session handling",
    //     "Improved frontend performance and usability across core application screens",
    //     "Implemented basic security safeguards (session validation, anomaly detection)",
    //     "Collaborated with engineering and design teams to deliver iterative product releases"
    //   ]
    // }
  ]
};


/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};


const enterpriseProjects = {
  title: "Enterprise Projects",
  subtitle: "Production systems across enterprise and AI-driven platforms",
  projects: [

    {
      company: "Leaf Craft",
      tags: ["AI", "LLM", "Backend"],
      image: require("./assets/images/unitsDb.jpg"),
      imgAlt: "UnitsDB",
      projectName: "UnitsDB",
      bullets: [
        "Built AI-driven platform converting natural language into deployable backend services",
        "Designed validation pipelines to ensure production-safe system generation",
        "Automated AWS provisioning and API deployment workflows",
        "Reduced backend setup time significantly using reusable generation pipelines"
      ],
      footerLink: [
        { name: "Visit", url: "https://unitsdb.com/" }
      ]
    },

    {
      company: "Leaf Craft",
      tags: ["AI", "Real-time", "Backend"],
      image: require("./assets/images/mivi.png"),
      imgAlt: "Mivi AI Buds",
      projectName: "Mivi AI Buds",
      bullets: [
        "Built backend systems enabling real-time multi-agent AI interactions",
        "Designed orchestration pipelines handling concurrent AI workflows",
        "Optimized low-latency communication for consumer-scale usage"
      ],
      footerLink: [
        { name: "Product", url: "https://www.mivi.in/products/ai-buds" }
      ]
    },

    {
      company: "Leaf Craft",
      tags: ["AI", "Data Systems"],
      image: require("./assets/images/unitsDb.jpg"),
      projectName: "AI MCP Server",
      bullets: [
        "Built AI system to query databases using natural language",
        "Translated queries into structured DB operations",
        "Generated visual insights dynamically for non-technical users"
      ],
      footerLink: [
        { name: "No Public Access", url: "" }
      ]
    },

    {
      company: "Yamaha",
      tags: ["Enterprise", "Distributed Systems"],
      image: require("./assets/images/Yamaha.webp"),
      projectName: "Dealer Management System",
      bullets: [
        "Built backend modules used across 5,000+ dealerships",
        "Designed event-driven workflows for inventory and transactions",
        "Handled large-scale distributed data processing"
      ],
      footerLink: [
        { name: "No Public Access", url: "" }
      ]
    },

    {
      company: "Yamaha",
      tags: ["Enterprise", "Backend"],
      image: require("./assets/images/Yamaha.webp"),
      projectName: "Yamaha Supplier Management Portal",
      bullets: [
        "Built backend for supplier onboarding and procurement workflows",
        "Streamlined vendor communication and tracking systems"
      ],
      footerLink: [
        { name: "No Public Access", url: "" }
      ]
    },

    {
      company: "Onelab",
      tags: ["AWS", "Data Systems"],
      image: require("./assets/images/kscada.png"),
      projectName: "Kscada",
      bullets: [
        "Designed real-time industrial data ingestion pipelines",
        "Used AWS Lambda for distributed processing",
        "Implemented validation and anomaly detection workflows"
      ],
      footerLink: [
        { name: "View", url: "https://kalyanistudio.com/kscada.html" }
      ]
    },
    {
  company: "Onelab",
  tags: ["Enterprise", "Backend", "Impact"],
  image: require("./assets/images/reliance.png"), 
  projectName: "Reliance Foundation Applications (Machli & KisanGrow)",
  bullets: [
    "Contributed to enterprise-scale applications used in rural ecosystems across India",
    "Built backend systems supporting large-scale data delivery and content workflows",
    "Worked on systems powering agricultural and fisheries advisory platforms",
    "Designed APIs and data pipelines for reliable content distribution in low-connectivity regions"
  ],
  footerLink: [
    { name: "Machli", url: "https://www.machli.reliancefoundation.org/" },
    { name: "KisanGrow", url: "https://play.google.com/store/apps/details?id=ai.rfis.content" }
  ]
}
  ],
  display: true,
  showFilter: true // Set true to show category filter, defaults to false
};
// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME PERSONAL PROJECTS",
  projects: [

  {
    image: require("./assets/images/cfa.png"),
    imgAlt: "CFA Analysis",
    projectName: "CFA Financial Analysis",
    projectDesc:
      "Macroeconomic analysis across 24 countries using World Bank and IMF datasets exploring inflation, GDP, and monetary policy trends.  (Power BI)",
    tags: [ "Analytics", "Finance"],
    footerLink: [
      { name: "View Report", url: "https://cdn.anilgulati.com/CFA.pdf" }
    ]
  },

  {
    image: require("./assets/images/gfd.png"),
    imgAlt: "Global Financial Development",
    projectName: "Global Financial Development ",
    projectDesc:
      "Financial system analysis across 200+ economies covering banking, equity, and debt market evolution. (Tableau)",
    tags: ["Analytics", "Finance"],
    footerLink: [
      { name: "View Report", url: "https://cdn.anilgulati.com/GFD.pdf" }
    ]
  },

  {
    image: require("./assets/images/excess_labs.webp"),
    imgAlt: "Excess Labs Logo",
    projectName: "Excess Labs",
    projectDesc:
      "Backend-as-a-Service platform with modular architecture for multi-database applications.",
    tags: ["Backend"],
    footerLink: [
      { name: "GitHub", url: "https://github.com/anilfromdit/Excess-Labs" }
    ]
  },

  {
    image: require("./assets/images/retina_dl.webp"),
    imgAlt: "Eye Diseases CNN",
    projectName: "Eye Disease Classification (CNN)",
    projectDesc:
      "Deep learning system for retinal disease detection using transfer learning, augmentation, and Grad-CAM explainability with strong evaluation metrics.",
    tags: ["AI", "Deep Learning"],
    footerLink: [
      { name: "Live Demo", url: "http://scan-my-lens.anilgulati.com/?utm_source=portfolio" }
    ]
  },

  {
    image: require("./assets/images/steam_ml.webp"),
    imgAlt: "Steam Recommender",
    projectName: "Steam Game Recommender",
    projectDesc:
      "Recommendation system using collaborative filtering and matrix factorization (ALS) with full ML pipeline from EDA to deployment.",
    tags: ["AI", "ML"],
    footerLink: [
      { name: "Dataset", url: "https://www.kaggle.com/datasets/antonkozyriev/game-recommendations-on-steam?select=users.csv" }
    ]
  },


  // 🔥 TIER 2 — SYSTEMS / PRODUCT THINKING

  {
    image: require("./assets/images/studio.png"),
    imgAlt: "Prompter Studio Logo",
    projectName: "Prompter Studio",
    projectDesc:
      "Browser-native video recording system using MediaRecorder API with local-first architecture and zero backend dependency.",
    tags: ["Frontend", "Systems"],
    footerLink: [
      { name: "Visit", url: "https://studio.anilgulati.com?utm_source=portfolio" }
    ]
  },

  {
    image: require("./assets/images/plagAi.webp"),
    imgAlt: "PlagAI Guard Logo",
    projectName: "PlagAI Guard",
    projectDesc:
      "AI-powered plagiarism detection using LLMs for semantic analysis with scalable microservices and async pipelines for production-grade performance.",
    tags: ["AI", "LLM", "Backend"],
    footerLink: [
      { name: "Live Demo", url: "https://aiplag.anilgulati.com/" }
    ]
  },


  

  // 🔥 TIER 3 — STRONG ENGINEERING PROJECTS

  {
    image: require("./assets/images/note.webp"),
    imgAlt: "Ctrl CV Logo",
    projectName: "CTRL CV",
    projectDesc:
      "Real-time collaboration platform with encrypted connections, live synchronization, and cursor tracking.",
    tags: ["Backend", "Realtime"],
    footerLink: [
      { name: "Start Collaborating", url: "https://ctrlcv.anilgulati.com" }
    ]
  },

  {
    image: require("./assets/images/lock.webp"),
    imgAlt: "Share X Logo",
    projectName: "ShareX Pro",
    projectDesc:
      "Secure file-sharing system using PGP encryption and AES-256 with expiring access links.",
    tags: ["Security", "Backend"],
    footerLink: [
      { name: "Share Files", url: "https://sharex.anilgulati.com" }
    ]
  },

  {
    image: require("./assets/images/fraud_ds.webp"),
    imgAlt: "Fraud Detection",
    projectName: "Loan & Transaction Fraud Detection",
    projectDesc:
      "End-to-end fraud detection pipeline with feature engineering, imbalance handling, and model comparison using cost-sensitive evaluation.",
    tags: ["ML",  "Analytics", "Finance"],
    footerLink: [
      { name: "Dataset", url: "https://www.kaggle.com/datasets/prajwaldongre/loan-application-and-transaction-fraud-detection?select=transactions.csv" }
    ]
  },

  // 🔥 TIER 4 — LOWER SIGNAL (KEEP LAST)

  
  {
    image: require("./assets/images/portfolio_v3.webp"),
    imgAlt: "Portfolio Website",
    projectName: "Portfolio Website",
    projectDesc:
      "Personal portfolio built with React showcasing projects and skills with modular architecture.",
    tags: ["Frontend"],
    footerLink: [{ name: "Live", url: "/" }]
  },

  {
    image: require("./assets/images/emart.webp"),
    imgAlt: "E-Mart",
    projectName: "E-Mart",
    projectDesc:
      "Full-stack e-commerce platform with secure payments and scalable APIs.",
    tags: ["Fullstack"],
    footerLink: [
      { name: "GitHub", url: "https://github.com/anilfromdit/E-Mart" }
    ]
  },

  {
    image: require("./assets/images/mmp.webp"),
    imgAlt: "Mark Me Present",
    projectName: "Mark Me Present",
    projectDesc:
      "QR-based attendance automation system with fraud detection safeguards.",
    tags: ["Android", "Fullstack"],
    footerLink: [
      { name: "GitHub", url: "https://github.com/anilfromdit/Mark-Me-Present-Pro--MMP" }
    ]
  },

  {
    image: require("./assets/images/wedo.webp"),
    imgAlt: "We Do",
    projectName: "We Do",
    projectDesc:
      "Android app for verified relationship systems with identity validation.",
    tags: ["Android", "Fullstack"],
    footerLink: [
      { name: "GitHub", url: "https://github.com/anilfromdit/WE-DO" }
    ]
  },

  {
    image: require("./assets/images/let_me_watch_anime.webp"),
    imgAlt: "Anime Extension",
    projectName: "Let Me Watch Anime",
    projectDesc:
      "Browser extension automating episode transitions for streaming platforms.",
    tags: ["Browser Extension"],
    footerLink: [
      { name: "GitHub", url: "https://github.com/anilfromdit/Let-Me-Watch-Anime" }
    ]
  }

],
  display: true, // Set false to hide this section, defaults to true
  showFilter: true // Set true to show category filter, defaults to false
};
// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Oracle Certified Associate, Java SE 8 Programmer",
      subtitle:
        `Oracle Certified Associate, Java SE 8 Programmer`,
      image: require("./assets/images/OCA.webp"),
      imgAlt:"Oracle Certified Associate, Java SE 8 Programmer Certificate",
      imageAlt: "Anil Gulati Oracle Java SE 8 Certification ",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=07BAB06DD77F2958AB2D9531C3839348DCD162F7851465D8C6BDEC28FE192489"
        }
      ]
    },
    {
  title: "AWS Certified Cloud Practitioner",
  subtitle: "AWS Certified Cloud Practitioner certification (In-Progress)",
     image: require("./assets/images/aws-cloud.webp"),
      imgAlt:"AWS Certified Cloud Practitioner Certificate (IN-PROGRESS)",
      imageAlt: "Anil Gulati AWS Certified Cloud Practitioner Certificate (IN-PROGRESS)",
  footerLink: [
    // { name: "Verify Certificate", url: "YOUR_VERIFICATION_URL" }
  ]
},
    {
      title: "Quizopedia 3rd Rank",
      subtitle:
        `Secured 3rd Position in "Quizopedia" organized by Classroom Study`,
      image: require("./assets/images/Quizopedia.webp"),
      imgAlt:"Anil Gulati Quizopedia 3rd Rank Certificate",
      imageAlt: "Anil Gulati Quizopedia 3rd rank certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://drive.google.com/file/d/1kK0IJ1O4wKV89NSQ1dl_EUxbM8RPaMGY/view?usp=sharing"
        }
      ]
    },
    {
      title: "Salesforce Certified Developer",
      subtitle:
        "Completed Salesforce Certification, mastering modules in Salesforce Fundamentals, Organizational Setup, Apex Development, Lightning Web Components (LWC), and more.",
      image: require("./assets/images/salesforce.webp"),
      imgAlt:"Salesforce Certified Developer Certificate",
      imageAlt: "Salesforce certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://drive.google.com/file/d/1DUoIM1iKDvQ-k-ikF6uZzhqMGQM_TYn6/view?usp=sharing"
        },
        {
          name: 'Verify Certificate',
          url: `https://smartinternz.com/internships/salesforce_certificates/16c66d09450b3dfe2bfe95657b562fa3`
        }
      ]
    },
    {
      title: "Front-End Web Development with React Certification",
      subtitle:
        `Authorized by The Hong Kong University of Science and Technology through Coursera - October 29, 2022"`,
      image: require("./assets/images/react_certificate.webp"),
      imageAlt: "React certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://drive.google.com/file/d/1guvHaHqglbV5hvqgwSVmOG-5ad_YfOcC/view?usp=sharing"
        },
        {
          name: 'Verify Certificate',
          url: `https://coursera.org/verif y/E5CKVJL4R5K3`
        }
      ]
    },
    {
      title: "Spring Boot 1.0 Essential Training Certification",
      subtitle:
        `Certified in Essential Spring Boot Training by LinkedIn Learning`,
      image: require("./assets/images/sprinboot_certificate.webp"),
      imageAlt: "SpringBoot certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://drive.google.com/file/d/1xNkZ63muDsWAsCcTlVaxHZs_xchCaFWi/view?usp=sharing"
        },
      ]
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  display: true // Set false to hide this section, defaults to true
};


const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+91-9256391000",
  email_address: "hi@anilgulati.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

const testimonies = {
  title: "Testimonies",
  testimony: [
    {
      image: require("./assets/images/chaitali.webp"),
      imgAlt:"Chaitali Sawant",
      name: "Chaitali Sawant",
      designation: "Senior Product Manager @ Kalayani Studio",
      feedback:"I would highly recommend Anil for any technology development project in React, Reactnative and Java. Despite his young age and ongoing studies, he demonstrates a level of skill and professionalism that's on par with seasoned professionals. His ability to tackle challenges head-on and provide foolproof solutions is truly impressive. I have no doubt that he will continue to excel in his career.", 
      footerLink: [
        
      ]
    },
    {
      image: require("./assets/images/lavanya.webp"),
      name: "Lavanya Singh",
      imgAlt:"Lavanya Singh",
      designation: "Product Owner @ Orange League Ventures",
      feedback: "I would highly recommend Anil for the role of SDE. I have seen Anil's work on Gativan, Machli and Kisangrow. He has been the Backbone of every project assigned to him. His technical capabilities are quite good. He is reliable, efficient and quick on any task assigned to him. He has been an asset to the organization.",
      footerLink: [
     
      ]
    },
    {
      image: require("./assets/images/rohit.webp"),
      name: "Rohith Aswarth",
      imgAlt:"Rohith Aswarth",
      designation: "Product Delivery Manager @ Leaf Craft",
      feedback: "I wholeheartedly recommend Mr. Anil Gulati for his outstanding skills in development and unwavering dedication. Anil's innovative thinking, remarkable communication abilities, and meticulous attention to detail set him apart. His commitment to excellence makes him a rare asset in the industry, and I confidently endorse him for any development role or project. Anil's contributions are sure to elevate the success of any team or organization he joins.",
      footerLink: [
      
      ]
    },
  

  ],
  display: true // Set false to hide this section, defaults to true
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  contactInfo,
  twitterDetails,
  isHireable,
  testimonies,
  enterpriseProjects
};
